import { render, staticRenderFns } from "./BarTrendWidgetForParentOrg.vue?vue&type=template&id=8a9f5cf0&scoped=true"
import script from "./BarTrendWidgetForParentOrg.vue?vue&type=script&lang=js"
export * from "./BarTrendWidgetForParentOrg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9f5cf0",
  null
  
)

export default component.exports